import * as React from 'react';
import {Checkbox, CheckboxProps, FormControlLabel} from '@material-ui/core';
import CheckedIcon from '@material-ui/icons/CheckCircle';
import UncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import IndeterminateIcon from '@material-ui/icons/RemoveCircleSharp';
import cn from 'classnames';
import './SelectButton.scss';
import {StudioTooltip} from '../../StudioTooltip';

export enum SELECT_BUTTON_STATE {
  SELECTED = 'selected',
  UNSELECTED = 'unselected',
  INDETERMINATE = 'indeterminate',
}

export const SelectButton = (props: CheckboxProps & {nativeTooltip?: string | null}) => {
  return props.nativeTooltip ? (
    <StudioTooltip title={props.nativeTooltip} placement="top">
      <Checkbox
        icon={<UncheckedIcon />}
        checkedIcon={<CheckedIcon />}
        indeterminateIcon={<IndeterminateIcon />}
        color="default"
        {...props}
        className={cn(props.className, 'select-button', props.checked && 'selected')}
      />
    </StudioTooltip>
  ) : (
    <Checkbox
      icon={<UncheckedIcon />}
      checkedIcon={<CheckedIcon />}
      indeterminateIcon={<IndeterminateIcon />}
      color="default"
      {...props}
      className={cn(props.className, 'select-button', props.checked && 'selected')}
    />
  );
};

export const SelectButtonLabel = ({
  label,
  ...rest
}: CheckboxProps & {label: string; nativeTooltip?: string | null}) => {
  return <FormControlLabel label={label} control={<SelectButton {...rest} />} />;
};
